export const MAX_ASSIGNMENT_BATCH_SIZE = 10;